import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import html2canvas from "html2canvas";

import {
  adjustBorderHeight,
  getQrCodeInfo,
  noInternetResponse,
  showToastMessage
} from "../../common/common";
import { getModelProfileData } from "../../data-services/edit-profile";
import { Network } from "@capacitor/network";
import axios from "axios";



const StepQR6SliceSuccessShare: React.FC = () => {
  const history = useHistory();
  const photoContainerRef = useRef<HTMLDivElement>(null);

  const [qrDetails, setQrDetails] = useState<any>();
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  const [photoFileName, setPhotoFileName] = useState('');
  const [compositeImageUrl, setCompositeImageUrl] = useState('');

  const getTalentPhoto = async () => {
    let profile_data: any = await getModelProfileData();
    // console.log('Profile data:', profile_data);
    
    const photoUrl = `${process.env.REACT_APP_HP_API_URL}/users/consumerImage?image=${profile_data?.data?.photos?.model_headshot}`;
    // Portrait test
    // const photoUrl = "http://localhost:8100/images/cons/qr6slice/p2-bottom.png"
    // Landscape test
    // const photoUrl = "http://localhost:8100/images/cons/qr6slice/images.jpg"
    setPhotoFileName(photoUrl);
    // console.log('Photo URL:', photoUrl);

    if (!profile_data?.success) {
      if (profile_data?.data?.errorCode == 0) {
        
        showToastMessage(profile_data?.data?.message);
        return;
      } else {
        // dispatch(authActions.logout());
        return;
      }
    }
    profile_data = profile_data.data;
    
    // Create composite image after photo is loaded
    if (photoUrl) {
      // console.log('Creating composite image with:', photoUrl);
      createCompositeImage(photoUrl);
    } else {
      console.log('No photo URL found');
    }
  }

  const createCompositeImage = async (photoUrl: string) => {
    try {
      // console.log('Starting composite image creation with URL:', photoUrl);
      
      // Create canvas for composite image
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      // Load the PNG frame first
      const frameImg = new Image();
      await new Promise((resolve, reject) => {
        frameImg.onload = () => {
          // console.log('Frame loaded successfully');
          resolve(true);
        };
        frameImg.onerror = (error) => {
          console.error('Frame loading error:', error);
          reject(error);
        };
        frameImg.src = '/images/cons/qr6slice/IG frame.png';
      });

      // Load the uploaded photo with CORS support
      const photoImg = new Image();
      photoImg.crossOrigin = 'anonymous';
      
      try {
        await new Promise((resolve, reject) => {
          photoImg.onload = () => {
            // console.log('Photo loaded successfully with CORS');
            resolve(true);
          };
          photoImg.onerror = (error) => {
            console.error('Photo CORS loading failed:', error);
            reject(error);
          };
          photoImg.src = photoUrl;
        });
      } catch (corsError) {
        console.log('CORS failed, trying fetch approach...');
        
        // Fallback: fetch the image as blob and create object URL
        try {
          const response = await fetch(photoUrl, { mode: 'cors' });
          const blob = await response.blob();
          const objectUrl = URL.createObjectURL(blob);
          
          await new Promise((resolve, reject) => {
            photoImg.onload = () => {
              console.log('Photo loaded successfully via fetch');
              resolve(true);
            };
            photoImg.onerror = reject;
            photoImg.src = objectUrl;
          });
        } catch (fetchError) {
          console.error('Both CORS and fetch failed:', fetchError);
          throw fetchError;
        }
      }

      // Set canvas dimensions to 2x resolution for higher quality
      canvas.width = 494;  // 247 * 2
      canvas.height = 708; // 354 * 2

      // Define the transparent area within the frame at 2x resolution
      const transparentArea = {
        x: (247 - 280) / 2 * 2, // Center the 280px width, then scale to 2x = -33 * 2 = -66
        y: 35 * 2, // 35px below frame top (20 + 15), scaled to 2x = 70
        width: 280 * 2, // 280px width scaled to 2x = 560
        height: 235 * 2 // 235px height (250 - 15) scaled to 2x = 470
      };

      // Calculate photo dimensions to fill the transparent area (cover mode)
      const photoAspectRatio = photoImg.width / photoImg.height;
      const areaAspectRatio = transparentArea.width / transparentArea.height;

      let photoDrawWidth, photoDrawHeight, photoDrawX, photoDrawY;

      if (photoAspectRatio > areaAspectRatio) {
        // Photo is wider - scale to fill height, crop width
        photoDrawHeight = transparentArea.height;
        photoDrawWidth = transparentArea.height * photoAspectRatio;
        photoDrawX = transparentArea.x + (transparentArea.width - photoDrawWidth) / 2; // Center horizontally
        photoDrawY = transparentArea.y;
      } else {
        // Photo is taller - scale to fill width, crop height
        photoDrawWidth = transparentArea.width;
        photoDrawHeight = transparentArea.width / photoAspectRatio;
        photoDrawX = transparentArea.x;
        photoDrawY = transparentArea.y + (transparentArea.height - photoDrawHeight) / 2; // Center vertically
      }

      // Draw the photo as background
      ctx.drawImage(photoImg, photoDrawX, photoDrawY, photoDrawWidth, photoDrawHeight);

      // Draw the frame on top, scaled to match our 2x canvas dimensions
      ctx.drawImage(frameImg, 0, 0, 494, 708);

      // Convert canvas to data URL and set as composite image
      const dataUrl = canvas.toDataURL('image/jpeg', 0.9);
      setCompositeImageUrl(dataUrl);

    } catch (error) {
      console.error('Error creating composite image:', error);
    }
  };

  const downloadPhotoContainer = async () => {

    const options: any = {
      method: "post",
      url: `${process.env.REACT_APP_HP_API_URL}/users/registerConsumerCTA`,
      data: {
        uuid: localStorage.getItem('uuid'),
        ctaType: "cta1",
        ctaLabel: 'Slice frame photo downloaded'
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    axios(options);

    
    if (!compositeImageUrl) {
      showToastMessage('No photo to download');
      return;
    }

    try {
      // Convert data URL to blob and download
      const response = await fetch(compositeImageUrl);
      const blob = await response.blob();
      
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'my-photo.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error downloading photo:', error);
      showToastMessage('Error downloading photo');
    }
  };

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(750);
    getTalentPhoto();
  }, []);

  const {
    handleSubmit,
    register,
    getValues,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      talent_mobile: "",
      talent_terms: false,
      talent_mobile_otp: "",
      promotion_text_msg: false,
      talent_fname: "",
      talent_lname: "",
      talent_display_name: "",
      talent_gender: "",
      talent_birth_date: "",
      talent_address: "",
      talent_apartment_no: "",
      talent_city: "",
      talent_country: "",
      talent_state: "",
      talent_email: "",
      marketing_emails: false,
      talent_passowrd: "",
      talent_zipcode: "",
    },
    mode: "onBlur",
  });


  return (
    <IonPage>

      <IonContent className={`lay__container--${qrDetails?.eventQrId}`}>
        <div className="lay__background">
          <img src="/images/cons/qr6slice/Background3.png" />
        </div>

        <div className="lay__background lay__background--border">
          <img src="/images/cons/qr6slice/Border.png" />
        </div>

        {typeof qrDetails != 'undefined' && 
          <div className={`lay__content--${qrDetails?.eventQrId}`}>

            <div className="img__first" style={{marginTop: '100px', marginBottom: '0px'}}>
              <div className="talent-signup__section-title talent-signup__section-title--smaller2">
                <img src="/images/cons/qr6slice/p5-img1.png" />
              </div>
            </div>

            <div className="" style={{
                maxWidth: '250px', 
                marginLeft: 'auto', 
                marginRight: 'auto', 
                marginTop: '10px',
                marginBottom: '20px'
              }}>
                <div ref={photoContainerRef} className="consumer-uploaded-photo-container">
                  {compositeImageUrl ? (
                    <img style={{width: '100%'}} src={compositeImageUrl} alt="Composite photo with frame" />
                  ) : (
                    <>
                      <div className="consumer-uploaded-photo--loading"> </div>
                      <img style={{marginTop: '0px', width: '100%'}} src="/images/cons/qr6slice/IG frame.png" />
                    </>
                  )}
                </div>
              </div>

            <div className="img__inline talent-signup__section-title--smaller3" style={{
              marginTop: '0px',
              marginBottom: '10px'}}>
              <div className="">
                <img src="/images/cons/qr6slice/p5-img2.png" />
              </div>
            </div>

            <div className="img__inline" style={{marginTop: '0px', zIndex: 3, width: '230px'}}>
              <div onClick={downloadPhotoContainer} style={{cursor: 'pointer'}}>
                <img src="/images/cons/qr6slice/CTA-Submit5.png" />
              </div>
            </div>

          </div>}
      </IonContent>

    </IonPage>
  );
};

export default StepQR6SliceSuccessShare;
